import { FC, useState, useMemo } from 'react';
import { Badge, Button, Drawer, Empty, Tabs } from 'antd';
import { WhatIsNewAlert } from './what-is-new-alert/what-is-new-alert';
import { NotificationItem } from './notification-item/notification-item';
import { useMarkedNotSuitableCaseIdAsReadIfVisited } from './utils';

const NOTIFICATION_TABS = [
  { label: 'Unread', key: 'unread' },
  { label: 'All', key: 'all' },
  { label: 'Read', key: 'read' },
];

const filterNotificationByView =
  (key: string) =>
  (notification: any): boolean =>
    key === 'all' ? true : key === 'unread' ? notification.isViewed === false : notification.isViewed === true;

type TPrimaryNotificationProps = {
  showNotifications: boolean;
  onSetShowNotifications: (b: boolean) => void;
  notifications: any[];
  unreadNotificationsCount: number;
  markNotificationsAs: (notis: any[], isViewed: boolean) => Promise<void>;
};

export const PrimaryNotification: FC<TPrimaryNotificationProps> = ({
  showNotifications,
  onSetShowNotifications,
  notifications,
  unreadNotificationsCount,
  markNotificationsAs,
}) => {
  const [selectedTab, setSelectedTab] = useState<string>('unread');
  useMarkedNotSuitableCaseIdAsReadIfVisited({ notifications, markNotificationsAs });

  const closeNotifications = () => {
    onSetShowNotifications(false);
  };

  const filteredNotifications = useMemo(
    () => notifications.filter(filterNotificationByView(selectedTab)),
    [selectedTab, notifications],
  );

  return (
    <Drawer
      placement="right"
      closable={false}
      onClose={closeNotifications}
      visible={showNotifications}
      contentWrapperStyle={{
        width: '380px',
        maxWidth: '90vw',
      }}
      footer={<WhatIsNewAlert toggleNotifications={closeNotifications} />}
      bodyStyle={{ padding: 0 }}
    >
      <div className="flex justify-content-between px-3 py-4 absolute z-5 b-white w-full">
        <div className="flex align-items-center">
          <span className="text-head">Notifications</span>
          <Badge dot={unreadNotificationsCount > 0} color="#FF00A8">
            <div
              style={{ backgroundColor: '#09263D', borderRadius: 5 }}
              className="flex justify-content-center align-items-center px-3 py-1 ml-2"
            >
              <span className="text-sm text-white font-semibold">{unreadNotificationsCount}</span>
            </div>
          </Badge>
        </div>
      </div>

      <Tabs
        size="large"
        defaultActiveKey={selectedTab}
        activeKey={selectedTab}
        onChange={setSelectedTab}
        tabBarStyle={{
          padding: '0 16px',
          marginBottom: '0px',
          position: 'absolute',
          top: '58px',
          width: '100%',
          zIndex: 4,
          backgroundColor: 'white',
        }}
        tabBarExtraContent={
          unreadNotificationsCount > 0 && selectedTab !== 'read' ? (
            <Button type="link" size="small" onClick={() => markNotificationsAs(filteredNotifications, true)}>
              Mark all as read
            </Button>
          ) : null
        }
      >
        {NOTIFICATION_TABS.map((notificationTab) => (
          <Tabs.TabPane tab={notificationTab.label} key={notificationTab.key} style={{ marginTop: '112px' }}>
            {filteredNotifications.map((n: any) => (
              <NotificationItem key={n.id} notification={n} markNotificationsAs={markNotificationsAs} />
            ))}
            {filteredNotifications.length === 0 && <Empty description="No notifications to show" />}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </Drawer>
  );
};
